import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AbstractWidgetComponent, AccountInfoService, AppClientConfigurationService, AppFrameContextService } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { VisitorUpfrontRegistationFilterModel } from '../../visitor-upfront-registration-filter/visitor-upfront-registration-filter.model';
import { DialogService } from '@sdbn/common';
import { PersonalVisitDetailsDialogComponent } from '../../../components/personal-visit/component/personal-visit-details-dialog/personal-visit-details-dialog.component';
import { VisitReservation } from '../../../components/visit-reservation/model/visit-reservation';
import { VisitReservationService } from '../../../components/visit-reservation/service/visitreservation.service';
import { Visit } from '../../../tmc-visit.model';
import { AppServerAPI } from '@sdbn/common';
import { PersonalVisit } from '../../../widgets/personal-visit-list/personal-visit-list.model';
import { WidgetStyle } from '@sdbn/common';

@Component({
    selector: 'app-visitor-upfront-registration-action-bar',
    templateUrl: './visitor-upfront-registration-action-bar.component.html',
    styleUrls: ['./visitor-upfront-registration-action-bar.component.scss'],
    standalone: false
})
export class VisitorUpfrontRegistrationActionBarComponent extends AbstractWidgetComponent implements OnInit {

  filterModel = new VisitorUpfrontRegistationFilterModel();

  visitReservation: VisitReservation;

  isEditAllowed = false;
  isDeleteAllowed = false;
  isShowAllowed = false;
  resendInvitationEnabled = false;

  constructor(
    private dialog: MatDialog,
    private visitReservationService: VisitReservationService,
    public translationService: TranslationService,
    private dialogService: DialogService,
    private appServerAPI: AppServerAPI,
    private appFrameContextService: AppFrameContextService,
    private configurationService: AppClientConfigurationService,
    private accountInfoService: AccountInfoService
  ) {
    super();
  }

  ngOnInit(): void {
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'selected-visitor-upfront-registration') {
      this.visitReservation = contextChange.value;
      this.updateActionStatus();
    }
    if (contextChange.key === 'visitor-upfront-registration-selection') {
      this.filterModel = contextChange.value;
      this.updateActionStatus();
    }
  }

  onSetElementAndContext() { }

  private updateActionStatus() {
    const yard = this.appFrameContextService.tenant.value;
    this.isEditAllowed = this.checkManageVisitReservationEnabledForUser(yard.key) && this.visitReservation != null && (
      this.visitReservation.arrival == null || this.visitReservation.arrival.length === 0)
      && (this.visitReservation.leave == null || this.visitReservation.leave.length === 0);

    this.isDeleteAllowed = this.checkManageVisitReservationEnabledForUser(yard.key) && this.isEditAllowed;
    this.isShowAllowed = this.checkManageVisitReservationEnabledForUser(yard.key) && this.visitReservation != null;
    this.resendInvitationEnabled = this.checkManageVisitReservationEnabledForUser(yard.key) && this.visitReservation != null && this.isEditAllowed;;
  }

  private checkManageVisitReservationEnabledForUser(yardKey: string): boolean {
    return this.accountInfoService.checkPrivilegeExistsForYardKey(yardKey, 'tmc-visit.manage-visitreservation');
  }

  /**
   * Register a new visit reservation.
   */
  newVisitReservation() {
    const visitorConfirmationDefault = this.configurationService.isPropertyTrue('tmc-visit.control.visitor-confirmation-default', true);
    this.dialogService.openMaxHeight(PersonalVisitDetailsDialogComponent,
      { model: new Visit({ reservation: true, confirmed: visitorConfirmationDefault }), action: 'new-upfront' }).afterClosed().subscribe(() => this.reloadUpfrontRegistationList());
  }

  /**
   * Edit the selected visit reservation.
   */
  editVisitReservation() {
    this.appServerAPI.execute<PersonalVisit>('/client/control/personalvisit/details', { id: this.visitReservation.id }).subscribe(result => {
      this.dialogService.openMaxHeight(PersonalVisitDetailsDialogComponent,
        { model: new Visit(result), action: 'edit-upfront' }).afterClosed().subscribe(() => this.reloadUpfrontRegistationList());
    });
  }

  /**
   * Opens the details of this visit reservation in readonly mode.
   */
  showVisitReservation() {
    this.appServerAPI.execute<PersonalVisit>('/client/control/personalvisit/details', { id: this.visitReservation.id }).subscribe(result => {
      this.dialogService.openMaxHeight(PersonalVisitDetailsDialogComponent,
        { model: new Visit(result), readOnly: true }).afterClosed().subscribe(() => this.reloadUpfrontRegistationList());
    });
  }

  deleteVisitReservation() {

    this.dialogService.showConfirm(
      'tmc.visitreservation.delete.confirm-dialog.title',
      'tmc.visitreservation.delete.confirm-dialog.message'
    ).afterClosed().subscribe(confirm => {
      if (confirm) {
        this.visitReservationService.deleteVisitReservation({ id: this.visitReservation.id }).subscribe(result => {
          this.reloadUpfrontRegistationList();
        });
      }
    });

  }

  public resendInvitation() {
    const ident = { id: this.visitReservation.id };

    this.dialogService.showConfirm(
      'tmc-visit.dialog.confirm-resend.title',
      'tmc-visit.dialog.confirm-resend.message'
    ).afterClosed().subscribe(confirm => {
      if (confirm) {
        this.executeResendInvitation(ident);
      }
    });

  }

  private executeResendInvitation(ident) {
    const url = `/client/control/personalvisit/resend-invitation`;
    this.appServerAPI.postWithArraybufferResponse<any>(url, ident).subscribe(result => {
      return;
    }, error => {
      console.error(error);
    });
  }

  private reloadUpfrontRegistationList() {
    this.dashboardContext.setContextValue('visitor-upfront-registration-changed', new Date().getTime());
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
